"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeForTagType = void 0;
var utils_1 = require("../../utils");
exports.getThemeForTagType = function (type, iconColor, countColor, isSelected) {
    switch (type) {
        case 'ANALYTICS':
            return {
                background: utils_1.theme.colors.NTWarmGrey[100],
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500],
                label: utils_1.theme.colors.darkBlue[500],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.NTDarkGrey[600],
                delete: utils_1.theme.colors.darkBlue[500],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'RM_ENTITY':
            return {
                background: utils_1.theme.colors.fadedGreen,
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.NTGreen[600],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.NTGreen[600],
                label: utils_1.theme.colors.NTGreen[600],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.NTGreen[600],
                delete: utils_1.theme.colors.NTGreen[600],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'IA_SUBJECT':
            return {
                background: utils_1.theme.colors.fadedLightGreen,
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.lightGreen[900],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.lightGreen[900],
                label: utils_1.theme.colors.lightGreen[900],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.lightGreen[900],
                delete: utils_1.theme.colors.lightGreen[900],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'IA_PEER':
            return {
                background: utils_1.theme.colors.fadedPurple,
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.purple[900],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.purple[900],
                label: utils_1.theme.colors.purple[900],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.purple[900],
                delete: utils_1.theme.colors.purple[900],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'IA_BENCHMARK':
            return {
                background: utils_1.theme.colors.fadedOrange,
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.orange[900],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.orange[900],
                label: utils_1.theme.colors.orange[900],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.orange[900],
                delete: utils_1.theme.colors.orange[900],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'CHART':
            return {
                background: 'white',
                icon: isSelected
                    ? iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500] : utils_1.theme.colors.NTDarkGrey[300],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500],
                label: 'black',
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.NTDarkGrey[900],
                delete: utils_1.theme.colors.NTDarkGrey[900],
                filter: '',
                hoverFilter: 'brightness(1)',
                border: '1px solid white',
                hoveredBorder: isSelected
                    ? "1px solid " + (iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500])
                    : '',
                opacity: isSelected ? '1' : '0.7',
            };
        case 'DARK':
            return {
                background: utils_1.theme.colors.aqua[700],
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.white,
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.white,
                label: utils_1.theme.colors.white,
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.white,
                delete: utils_1.theme.colors.white,
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'SUGGESTED':
            return {
                background: '#197bae',
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.white,
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.white,
                label: utils_1.theme.colors.white,
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.white,
                delete: utils_1.theme.colors.white,
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'LIGHT_GREEN':
            return {
                background: '#EAF1EE',
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.NTGreen[700],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.NTGreen[700],
                label: utils_1.theme.colors.NTGreen[700],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.NTGreen[700],
                delete: utils_1.theme.colors.NTGreen[700],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        case 'LIGHT_BLUE':
            return {
                background: '#D2EFFF',
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[800],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[800],
                label: utils_1.theme.colors.darkBlue[800],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.darkBlue[800],
                delete: utils_1.theme.colors.darkBlue[800],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
        default:
            return {
                background: utils_1.theme.colors.fadedBlue,
                icon: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500],
                hoveredIconColor: iconColor !== null && iconColor !== void 0 ? iconColor : utils_1.theme.colors.darkBlue[500],
                label: utils_1.theme.colors.darkBlue[500],
                count: countColor !== null && countColor !== void 0 ? countColor : utils_1.theme.colors.darkBlue[500],
                delete: utils_1.theme.colors.darkBlue[500],
                filter: isSelected ? 'brightness(0.9) saturate(3)' : '',
                hoverFilter: 'brightness(0.9) saturate(3)',
                border: '',
                hoveredBorder: '',
                opacity: '1',
            };
    }
};
